import React from 'react';
import './src/styles/global.css';
import './src/styles/homepage.css';

import AppLayout, { isAppLayoutRoute } from './src/components/Homepage/AppLayout';

export const wrapPageElement = ({ element, props }) => {
  if (isAppLayoutRoute(props.location.pathname)) {
    return (
      <AppLayout pathname={props.location.pathname}>
        {element}
      </AppLayout>
    );
  }
  return element;
};

/** Back/forward keeps saved scroll; forward nav jumps to top immediately. */
export const shouldUpdateScroll = ({ action }) => {
  if (action === 'POP') return false;
  if (typeof window !== 'undefined') window.scrollTo(0, 0);
  return [0, 0];
};
